import styled from 'styled-components'

import { BlockContent } from 'components/layout'
import mediaQueries from 'components/media-queries'

export const SearchContainer = styled(BlockContent)`
  background-color: rgba(255, 255, 255, 0.35);
  border-radius: 3px;
  margin: ${({ dynamicMargin }) => `${dynamicMargin || -230}px`} auto 0;
  padding: 15px;
  width: 100%;
  position: relative;

  ${mediaQueries.tablet`
    padding: 0;
  `};
`

export const SearchPanel = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 3px;
  padding: 20px 0;
  width: 100%;

  ${mediaQueries.tablet`
    padding: 20px 0;
  `};
`

export const TabsContainer = styled.div`
  width: 100%;
  padding: 20px 70px 20px 50px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.colors.white};

  ${mediaQueries.tablet`
    padding: 20px 65px;
  `};

  ${mediaQueries.mobile`
    padding: 0 20px;
  `}
`

const Tab = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
  margin: 0 10px;
  font-size: 18px;
  font-family: ${({ theme }) => theme.fonts.regular};
  text-decoration: none;
  :link {
    color: ${({ theme }) => theme.colors.gray};
  }
  :visited {
    color: inherit;
  }
  :hover {
    color: inherit;
  }
  :selected {
    color: ${({ theme }) => theme.colors.blue};
  }

  ${mediaQueries.mobile/*Hides visually but not for screen-readers*/ `
    clip: rect(0 0 0 0); 
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap; 
    width: 1px;
  `};
`

export { Tab }
